export const allowBypassDomains = [
    // "http://localhost:4200/", 
    // "http://localhost:4401/",
    "https://d3h4m0g2lmrmq6.cloudfront.net/",
    "https://qc4.mathproficiencytest.ca/",
    "https://d3k4cvve5iw7mr.cloudfront.net/",
    "https://qc7.vretta.com/",
    "https://d24a8vriqswfok.cloudfront.net/",
]